document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-cc-root]');
  if (!root) return;

  const slider = root.querySelector('#cc-price-slider');
  const input = root.querySelector('#cc-price-input');
  const quantity = root.querySelector('#cc-quantity');
  const service = root.querySelector('#cc-service');
  const region = root.querySelector('#cc-region');

  const payout = root.querySelector('#cc-payout');
  const liveValue = root.querySelector('#cc-price-live');

  const serviceLinkBox = root.querySelector('#cc-service-link-box');
  const serviceLinkText = root.querySelector('#cc-service-link-text');
  const serviceLink = root.querySelector('#cc-service-link');

  if (
    !slider ||
    !input ||
    !quantity ||
    !service ||
    !region ||
    !payout ||
    !liveValue ||
    !serviceLinkBox ||
    !serviceLinkText ||
    !serviceLink
  ) {
    return;
  }

  const SERVICE_LINKS = {
    standard: 'https://cashyourcards.de/products/standard',
    lot: 'https://cashyourcards.de/products/lot',
    express: 'https://cashyourcards.de/products/express'
  };

  const SERVICE_TEXTS = {
    standard: 'Du kannst direkt mit dem ausgewählten Standard Service fortfahren.',
    lot: 'Du kannst direkt mit dem ausgewählten LOT Service fortfahren.',
    express: 'Du kannst direkt mit dem ausgewählten Express Service fortfahren.'
  };

  function formatEuro(value) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value) || 0);
  }

  function updateSliderBackground(value) {
    const min = Number(slider.min) || 0;
    const max = Number(slider.max) || 10000;
    const percent = max > min ? ((value - min) / (max - min)) * 100 : 0;

    slider.style.background = `linear-gradient(
      to right,
      #9b9481 0%,
      #9b9481 ${percent}%,
      rgba(255,255,255,0.12) ${percent}%,
      rgba(255,255,255,0.12) 100%
    )`;
  }

  function syncPrice(value) {
    const min = Number(slider.min) || 0;
    const max = Number(slider.max) || 10000;

    let v = Number(value);
    if (!Number.isFinite(v)) v = min;
    v = Math.max(min, Math.min(max, v));

    slider.value = v;
    input.value = v;
    liveValue.textContent = new Intl.NumberFormat('de-DE').format(v) + ' €';

    updateSliderBackground(v);
  }

  function renderSelectedService(serviceType) {
    serviceLinkText.textContent = SERVICE_TEXTS[serviceType] || SERVICE_TEXTS.standard;
    serviceLink.href = SERVICE_LINKS[serviceType] || SERVICE_LINKS.standard;
    serviceLink.textContent = 'Zum ausgewählten Service';
  }

  function calculate() {
    const price = Number(input.value) || 0;
    const qty = Math.max(1, Number(quantity.value) || 1);
    const serviceType = service.value;
    const regionType = region.value;
    const pricePerCard = qty > 0 ? price / qty : 0;

    renderSelectedService(serviceType);

    if (price <= 0) {
      payout.textContent = 'Bitte gib einen möglichen Verkaufspreis ein';
      serviceLinkBox.style.display = 'none';
      return;
    }

    serviceLinkBox.style.display = 'block';

    let fixedFee = 0;
    let percentFee = 0;

    if (pricePerCard >= 5000) {
      fixedFee = 4.5 * qty;
      percentFee = 0.05;
    } else if (pricePerCard >= 2500) {
      fixedFee = 4.5 * qty;
      percentFee = 0.07;
    } else if (pricePerCard >= 1500) {
      fixedFee = 4.5 * qty;
      percentFee = 0.085;
    } else {
      if (serviceType === 'standard') {
        fixedFee = 4.5 * qty;
        percentFee = 0.099;
      }

      if (serviceType === 'lot') {
        if (qty <= 5) {
          fixedFee = 6;
          percentFee = 0.0999;
        } else {
          fixedFee = 8;
          percentFee = 0.0999;
        }
      }

      if (serviceType === 'express') {
        if (qty === 1) {
          fixedFee = 15 * qty;
        } else if (qty <= 4) {
          fixedFee = 12.5 * qty;
        } else {
          fixedFee = 10 * qty;
        }

        percentFee = 0.099;
      }
    }

    let internationalFee = 0;

    if (regionType === 'uk') {
      internationalFee = 0.012;
    }

    if (regionType === 'intl1') {
      internationalFee = 0.016;
    }

    if (regionType === 'rest') {
      internationalFee = 0.033;
    }

    const serviceCost = price * percentFee;
    const internationalCost = price * internationalFee;
    const payoutValue = price - fixedFee - serviceCost - internationalCost;

    payout.textContent = formatEuro(Math.max(0, payoutValue));
  }

  slider.addEventListener('input', function () {
    syncPrice(slider.value);
    calculate();
  });

  input.addEventListener('input', function () {
    syncPrice(input.value);
    calculate();
  });

  quantity.addEventListener('input', function () {
    if ((Number(quantity.value) || 0) < 1) {
      quantity.value = 1;
    }
    calculate();
  });

  service.addEventListener('change', calculate);
  region.addEventListener('change', calculate);

  syncPrice(input.value || slider.value || 0);
  calculate();
});